/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AlertController, IonRouterOutlet, ModalController, NavParams, Platform, PopoverController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@shared/services/user.service';
import { UtilService } from '@shared/utils/util';
import { Subscription } from 'rxjs';
import { Preferences } from '@capacitor/preferences';
import { environment } from 'src/environments/environment';
import { PurchaseService } from 'src/app/services/purchase.service';
import { Capacitor } from '@capacitor/core';
import { EventService } from '@shared/services/event.service';
import { ShareProfileComponent } from '@shared/components/share-profile/share-profile.component';
import { ProfileSharePerCarrotsComponent } from '@shared/components/profile-share-per-carrots/profile-share-per-carrots.component';
import { InAppBrowser } from '@capgo/inappbrowser';
import { Device } from '@capacitor/device';

@Component({
  selector: 'app-store',
  templateUrl: './store.page.html',
  styleUrls: ['./store.page.scss'],
  providers: [UserService, UtilService,IonRouterOutlet]
})
export class StorePage implements OnInit {
  //=======| Pedro |========

  protected coinsOwned: number = 0;

  //-------| Premium |-------- => default
  protected premiumExpireDate: Date | any;

  protected premiumMonthlyCoins: number = 3;

  protected premiumPrice: number = 1.49;
  protected premiumPriceMonth: number = 0.80;
  public userData: any;
  protected selection = ["unselected", "unselected", "unselected", "unselected"];
  public coinsDigits = { digits: 0 };
  protected showingCoins: boolean = false;
  protected showingAdvantage: boolean = false;
  public isNative: boolean = true;
  public type: string = '';
  public showContinueWithoutJoining = false
  public showProfileSharePerCarrots: boolean = false;
  public isAndroid15: boolean = false;

  downloadApp() {
    const url = environment.adjustDownloadLink;
    InAppBrowser.open({ url: url });
  }
  protected greyPremiumButton: boolean = true;
  protected greyCoinsButton: boolean = false;
  private eventSubscription: Subscription|any;
  public backButton: Subscription|any;
  private purchaseSuccessful: boolean = false;
  /** Slide inicial do swiper de vantagens (sparks): SuperLike=0, FireBoost=1, Elogio=2. */
  public advantageInitialSlide = 0;
  @ViewChild('advantageSwiper') advantageSwiperRef: ElementRef | undefined;
  constructor(public platform: Platform,
    public navParams: NavParams,
    public userService: UserService,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    private translate: TranslateService,
    public purchaseServiceProvider: PurchaseService,
    private util: UtilService,
    public modalCtrl: ModalController,
    public popoverCtrl: PopoverController,
    private eventService: EventService) {
  
    this.util.initTranslate();
  }

  ionViewWillEnter() {
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        if(this.isNative){
          this.backPage();
        } else {
          this.dismiss();
        }
      }); 
    }

    this.util.initTranslate();
    this.isNative = this.util.isNative();
    const type = this.navParams.get('type');
    this.type = type !== null ? type : '';
    this.showContinueWithoutJoining = this.navParams.get('showContinueWithoutJoining');
    this.advantageInitialSlide = this.resolveAdvantageSlide(this.navParams.get('origin'));

    this.platform.ready().then(async () => {
      this.selection[2] = "selected";
      this.isNative = Capacitor.isNativePlatform();

      // Detectar Android 15
      if (this.platform.is('android')) {
        try {
          const deviceInfo = await Device.getInfo();
          const androidVersion = parseInt(deviceInfo.osVersion);
          this.isAndroid15 = androidVersion >= 15;
        } catch (error) {
          console.error('Error getting device info:', error);
        }
      }
    });

    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (val === null) {
        return;
      } else if (val.needsEmailValidation) {
        return;
      }
      this.userData = val;

      Preferences.get({ key: 'LOCAL_PROMOTION' }).then((val: any) => {
        val = val.value ? JSON.parse(val.value) : null;
        if (val != null) {
          const LOCAL_PROMOTION = val;
          if (LOCAL_PROMOTION != null && !this.dismissedPromotion) {
            const promotion = LOCAL_PROMOTION;
            if (promotion.promoClientEndsCalculated != null) {
              const nowNumber: number = (new Date()).getTime();
              const distance: number = promotion.promoClientEndsCalculated - nowNumber;

              if (distance > 1) {
                // this.openPromotion();
              } else {
                Preferences.remove({ key: 'LOCAL_PROMOTION' }).then((_val) => {
                  console.log('LOCAL_PROMOTION removed from DB');
                });
              }
            } else {
              // not started yet.
              // this.openPromotion();
            }
          }
        }
      });

      const showingCoinsParam: boolean = this.navParams.get('showCoins');
      if (showingCoinsParam != undefined && showingCoinsParam != null) {
        this.showingCoins = showingCoinsParam;
      }

      if (this.userData?.coins !== null) {
        this.coinsOwned = this.userData?.coins;
        const coinsStr = '' + this.userData?.coins;
        this.coinsDigits.digits = coinsStr.length;
      }

      this.switchStore(this.type);
      this.purchaseServiceProvider.configurePurchasing();
    });

    setTimeout(() => {
      if (!this.isSomePriceLoaded()) {
        this.showAlertCouldNotLoadVegglyMarket();
      }
    }, 5000);
  }

  ionViewWillLeave() {
    if(this.backButton){
      this.backButton.unsubscribe();
    }
  
  }

  ngOnInit() {
    this.isNative = Capacitor.isNativePlatform();
  }

  /**
   * Mapeia o origin do fluxo para o índice do swiper de vantagens da loja de sparks.
   * Ordem no HTML: 0 SuperLike, 1 FireBoost, 2 Elogio/Recadinho.
   */
  private resolveAdvantageSlide(origin: string | null | undefined): number {
    if (origin === 'VegBoost') {
      return 1;
    }
    if (origin === 'Intro' || origin === 'Recadinho' || origin === 'compliment') {
      return 2;
    }
    // SuperLike (e default) → 0
    return 0;
  }

  private slideAdvantageToOrigin() {
    try {
      const targetSlide = this.advantageInitialSlide;
      const swiper = this.advantageSwiperRef?.nativeElement?.swiper;
      if (!swiper || targetSlide <= 0) {
        return;
      }
      // Sem speed 0: anima passando pelos slides intermediários (igual store-v2 / teleport).
      if (typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(targetSlide);
      } else if (swiper.activeIndex !== targetSlide) {
        swiper.slideTo(targetSlide);
      }
    } catch {
      // swiper ainda não pronto
    }
  }

  private dismissedPromotion: boolean = false;

  public async fetchRemoteConfig() {

    // await this.firebasePlugin.fetch(async function (result:any) {

    //   alert('Result Fech: ' + JSON.stringify(result));

    // }, function () {
    //   // error callback
    // });

  }


  ionViewDidEnter() {
    // Posiciona o swiper de vantagens na oferta do fluxo (SuperLike / FireBoost / Elogio).
    setTimeout(() => this.slideAdvantageToOrigin(), 1);

    this.eventSubscription = this.eventService.getEvent('updateCoins').subscribe(coins => {
      if (coins) {
        this.userData.coins = coins;
        this.coinsOwned = this.userData?.coins;
        const coinsStr = '' + this.userData?.coins;
        this.coinsDigits.digits = coinsStr.length;
      }
    });


    Preferences.get({ key: 'USER_DATA' }).then((val: any) => {
      val = val.value ? JSON.parse(val.value) : null;
      if (val === null) {
        // this.navCtrl.push(LoginPage);
        return;
      } else if (val.needsEmailValidation) {
        // this.navCtrl.push(EmailValidationPage);

        //let modal = this.modalCtrl.create(EmailValidationPage, {showBackdrop:true});
        //modal.present();
        return;
      }
      this.userData = val;

      Preferences.get({ key: 'LOCAL_PROMOTION' }).then((val: any) => {
        val = val.value ? JSON.parse(val.value) : null;
        if (val != null) {
          const LOCAL_PROMOTION = val;
          if (LOCAL_PROMOTION != null && !this.dismissedPromotion) {
            const promotion = LOCAL_PROMOTION;
            if (promotion.promoClientEndsCalculated != null) {
              const nowNumber: number = (new Date()).getTime();
              const distance: number = promotion.promoClientEndsCalculated - nowNumber;

              if (distance > 1) {
                // this.openPromotion();
              } else {
                Preferences.remove({ key: 'LOCAL_PROMOTION' }).then((_val) => {
                  console.log('LOCAL_PROMOTION removed from DB');
                });
              }

            } else {
              // not started yet.
              // this.openPromotion();
            }
          }
        }

      });





      const showingCoinsParam: boolean = this.navParams.get('showCoins');

      if (showingCoinsParam != undefined && showingCoinsParam != null) {
        this.showingCoins = showingCoinsParam;
      }

      if (this.userData?.coins !== null) {
        this.coinsOwned = this.userData?.coins;
        const coinsStr = '' + this.userData?.coins;
        this.coinsDigits.digits = coinsStr.length;
      }
      this.purchaseServiceProvider.configurePurchasing();

      //this.isNative = this.platform.is('android') || !this.platform.is('android');
      //alert(document.URL);

    });

    setTimeout(() => {
      if (!this.isSomePriceLoaded()) {
        this.showAlertCouldNotLoadVegglyMarket();
      }
    }, 5000);
  }


  isSomePriceLoaded() {
    if (this.isPriceLoaded(1, 'coin') 
      || this.isPriceLoaded(10, 'coin')
      || this.isPriceLoaded(50, 'coin')
      || this.isPriceLoaded(100, 'coin')
      || this.isPriceLoaded(1, 'premium')
      || this.isPriceLoaded(3, 'premium')
      || this.isPriceLoaded(6, 'premium')
      || this.isPriceLoaded(12, 'premium')
      || this.isPriceLoaded(1, 'club')
      || this.isPriceLoaded(3, 'club')
      || this.isPriceLoaded(6, 'club')
      || this.isPriceLoaded(12, 'club')) {
        return true;
      }
      return false;
  }

  async showAlertCouldNotLoadVegglyMarket() {
    const alert = this.alertCtrl.create({
      subHeader: this.translate.instant('couldNotLoadVegglyMarket'),
      buttons: [
        {
          text: 'OK',
          handler: () => {
            //this.loader.dismiss();
          }
        }
      ]
    });
    (await alert).present();
  }

  openPromotion() {
    // let modal = this.modalCtrl.create(AvocadoPromotionPage, { me: this.userData }, { showBackdrop: true });
    // modal.onDidDismiss(data => {
    //   this.dismissedPromotion = true;
    // });
    // modal.present();

  }

  openLinkPlayStore() {
    InAppBrowser.open({ url: 'https://play.google.com/store/account/subscriptions' });
  }

  getExpirationDateExists() {
    if (this.userData !== undefined) {
      if (this.userData[environment.products.club.id] !== undefined ||
        this.userData[environment.products.club_3_months.id] !== undefined ||
        this.userData[environment.products.club_6_months.id] !== undefined ||
        this.userData[environment.products.club_12_months.id] !== undefined) {

        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }

  }

  getExpirationDate(): string {
    if (this.userData === undefined) return '';
    let expiryTimeMillis = 0;
    const read = (val: unknown): number => {
      if (val == null || val === false || val === true) return 0;
      if (typeof val === 'object' && val !== null && '$numberLong' in val) {
        const n = parseInt((val as { $numberLong: string }).$numberLong, 10);
        return typeof n === 'number' && !isNaN(n) ? n : 0;
      }
      const n = typeof val === 'number' ? val : Number(val);
      return typeof n === 'number' && !isNaN(n) && n > 0 ? n : 0;
    };
    const products = [
      this.userData.vegglypremium,
      this.userData.vegglypremium3months,
      this.userData.vegglypremium6months,
      this.userData.vegglypremium12months,
    ].filter(Boolean);
    for (const p of products) {
      const t = p?.transaction?.expiryTimeMillis;
      if (t != null) { const n = read(t); if (n > expiryTimeMillis) expiryTimeMillis = n; }
    }
    const clubIds = [environment.products.club.id, environment.products.club_3_months.id, environment.products.club_6_months.id, environment.products.club_12_months.id];
    for (const id of clubIds) {
      const product = this.userData[id];
      if (product?.transaction?.expiryTimeMillis != null) {
        const n = read(product.transaction.expiryTimeMillis);
        if (n > expiryTimeMillis) expiryTimeMillis = n;
      }
    }
    if (expiryTimeMillis > 0) {
      const expiryDate = new Date(expiryTimeMillis);
      if (!isNaN(expiryDate.getTime())) {
        return expiryDate.toLocaleDateString(this.userData.language ?? 'en');
      }
    }
    return '';
  }

  eachUnitWithDecimals(price: number, discountOffer: number) {
    //console.log("!!!Preço colocado: " + price + "\n!!!Disconto dado: "+ discountOffer);
    return (price * discountOffer / 100).toFixed(2);
  }

  isPriceLoaded(packageSelected: number, type: string): boolean {
    // return true;
    switch (type) {
      case 'coins':
        switch (packageSelected) {
          case 1:
            if (this.purchaseServiceProvider.oneCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          case 10:
            if (this.purchaseServiceProvider.tenCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          case 50:
            if (this.purchaseServiceProvider.fiftyCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          case 100:
            if (this.purchaseServiceProvider.hundredCoinPriceSet) {
              return true;
            } else {
              return false;
            }

          default:
            console.log('!! Saiu do isPriceLoaded por default ==> COINS !!');
            return false;
        }

      case 'club':
        switch (packageSelected) {
          case 1:
            if (this.purchaseServiceProvider.clubPriceSet) {
              return true;
            } else {
              return false;
            }

          case 3:
            if (this.purchaseServiceProvider.club_3_monthsPriceSet) {
              return true;
            } else {
              return false;
            }

          case 6:
            if (this.purchaseServiceProvider.club_6_monthsPriceSet) {
              return true;
            } else {
              return false;
            }

          case 12:
            if (this.purchaseServiceProvider.club_12_monthsPriceSet) {
              return true;
            } else {
              return false;
            }

          default:
            //console.log('!! Saiu do isPriceLoaded por default ==> PREMIUM !!');
            return false;
        }
    }
    return true;
  }

  getPricesString(priceShown: number, type: string): string {
    switch (type) {
      case 'coins':
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.oneCoinPrice;

          case 10:
            return this.purchaseServiceProvider.tenCoinPrice;

          case 50:
            return this.purchaseServiceProvider.fiftyCoinPrice;

          case 100:
            return this.purchaseServiceProvider.hundredCoinPrice;

          default:
            console.log('!! Saiu por default ==> COINS !!');
            return '';
        }

      case 'club':
        //console.log('!! Entrou no getPricesString() => PREMIUM !!');
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.clubPrice;

          case 3:
            return this.purchaseServiceProvider.club_3_monthsPrice;

          case 6:
            return this.purchaseServiceProvider.club_6_monthsPrice;

          case 12:
            return this.purchaseServiceProvider.club_12_monthsPrice;

          default:
            //console.log('!! Saiu por default ==> PREMIUM !!');
            return '';
        }

      default:
        return '';

    }
    return '';
  }

  getPricesNumberMicro(priceShown: number, type: string): number {
    switch (type) {
      case 'coins':
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.oneCoinPriceMicros;

          case 10:
            return this.purchaseServiceProvider.tenCoinPriceMicros;

          case 50:
            return this.purchaseServiceProvider.fiftyCoinPriceMicros;

          case 100:
            return this.purchaseServiceProvider.hundredCoinPriceMicros;

          default:
            return 0;
        }

      case 'club':
        switch (priceShown) {
          case 1:
            return this.purchaseServiceProvider.clubPriceMicros;

          case 3:
            return this.purchaseServiceProvider.club_3_monthsPriceMicros;

          case 6:
            return this.purchaseServiceProvider.club_6_monthsPriceMicros;

          case 12:
            return this.purchaseServiceProvider.club_12_monthsPriceMicros;

          default:
            return 0;
        }

      default:
        return 0;

    }

    return 0;
  }

  switchStore(storeName: string) {
    if (storeName == 'club') {
      this.showingCoins = false;
    }
    else {
      this.showingCoins = true;
    }
  }

  switchButtonColours(button: string) {
    if (button == 'premium') {
      this.greyCoinsButton = false;
      this.greyPremiumButton = true;

    } else {
      this.greyCoinsButton = true;
      this.greyPremiumButton = false;
    }

  }


  dismiss() {
    // Just exit
    this.modalCtrl.dismiss();
  }

  backPage() {
    if (this.showingCoins && (this.navParams.get('origin') === 'VegBoost' || this.navParams.get('origin') === 'SuperLike')) {
      if (this.navParams.get('origin') === 'VegBoost' && this.userData?.coins < environment.priceVegBoost && !this.purchaseSuccessful) {
        this.profileSharePerCarrots();
      } else if (this.navParams.get('origin') === 'SuperLike' && this.userData?.coins < environment.priceSuperLike && !this.purchaseSuccessful) {
        this.profileSharePerCarrots();
      } else {
        this.modalCtrl.dismiss();
      }
    } else {
      this.modalCtrl.dismiss();
    }
  }

  async profileSharePerCarrots() {
    const modal = await this.modalCtrl.create({
      component: ProfileSharePerCarrotsComponent,
      componentProps: {
        userId: this.userData,
        srcIconCoin: 'assets/imgs/spark.svg',
        shareBaseUrl: this.userService.getShareBaseUrl()
      },
      cssClass: 'custom-class-modal' 
    });
    (await modal).onDidDismiss().then((_val:any) => {
      this.modalCtrl.dismiss();
    });
    modal.present();
  }

  async profileShare() {
    const modal = await this.modalCtrl.create({
      component: ShareProfileComponent,
      componentProps: {
        userId: this.userData?._id.$oid,
        shareBaseUrl: this.userService.getShareBaseUrl(),
        shareTextKey: 'shareYourProfileText',
        shareTitleKey: 'shareYourProfile'
      },
      cssClass: 'custom-class-modal' 
    });
    modal.present();
  }

  unselectPackages() {
    this.selection = ["unselected", "unselected", "unselected", "unselected"];
  }

  changeToSubscriptions() {
    this.unselectPackages();

    this.showingCoins = false;
  }

  changeToCoins() {
    this.unselectPackages();

    this.showingCoins = true;
  }

  optionClicked(option: number) {
    console.log('store.optionClicked');

    this.unselectPackages();

    this.selection[option] = "selected";
  }

  buy() {
    this.redirectToPurchase();
  }

  async showModalWaitForApproval() {
    const alert = await this.alertCtrl.create({
      subHeader: this.translate.instant('waitForApproval'),
      buttons: [
        {
          text: this.translate.instant('cancel'),
          handler: () => {
            console.log('cancel clicked');
            return;

          }
        },
        {
          text: 'OK',
          handler: () => {
            console.log('OK clicked');
            this.redirectToPurchase();
            return;
          }
        }
      ]
    });

    await alert.present();
  }

  async redirectToPurchase() {
    let purchaseId: string | null = null;
  
    if (this.showingCoins) {
      if (this.selection[0] === "selected") {
        // Buy 1
        purchaseId = this.purchaseServiceProvider.oneCoinId;
      } else if (this.selection[1] === "selected") {
        // Buy 10
        purchaseId = this.purchaseServiceProvider.tenCoinsId;
      } else if (this.selection[2] === "selected") {
        // Buy 50
        purchaseId = this.purchaseServiceProvider.fiftyCoinsId;
      } else if (this.selection[3] === "selected") {
        // Buy 100
        purchaseId = this.purchaseServiceProvider.hundredCoinsId;
      } else {
        this.util.presentToast(this.toastCtrl, this.translate.instant('pleaseSelectPackage'), 5000);
        return;
      }
    } else {
      if (this.selection[0] === "selected") {
        // Buy 1 month
        purchaseId = this.purchaseServiceProvider.clubId;
      } else if (this.selection[1] === "selected") {
        // Buy 3 months
        purchaseId = this.purchaseServiceProvider.club_3_monthsId;
      } else if (this.selection[2] === "selected") {
        // Buy 6 months
        purchaseId = this.purchaseServiceProvider.club_6_monthsId;
      } else if (this.selection[3] === "selected") {
        // Buy 12 months
        purchaseId = this.purchaseServiceProvider.club_12_monthsId;
      } else {
        this.util.presentToast(this.toastCtrl, this.translate.instant('pleaseSelectPlan'), 5000);
        return;
      }
    }
  
    // Execute purchase and check for success
    if (purchaseId) {
      try {
        const result: any = await this.purchaseServiceProvider.purchase(this.userData, purchaseId, this.coinsDigits);
        if (result) {
          this.purchaseSuccessful = true;
        }
      } catch (error) {
        console.error("Purchase failed:", error);
      }
    }
  }

  openAdvantageInfo() {

    this.showingAdvantage = !this.showingAdvantage;

  }

  dismissModal() {
    if (this.showingAdvantage) {
      this.showingAdvantage = false;
    }
  }


  formatNoDecimal(num: number) {
    return (Math.round(num * 100) / 100).toFixed(0);
  }

  format2Decimal(num: number) {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  formatMicro(priceMicro: number, units: number) {
    const num: number = priceMicro / (units * 1000 * 1000);
    return this.format2Decimal(num);
  }


  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }


}
